import React from 'react'
import gql from 'graphql-tag'
import Heading from 'components/shared/Heading'
import Query from 'components/shared/Query'
import OrderNavigation from 'components/shared/OrderNavigation'
import Button from 'components/shared/Button'
import './index.scss'

const segmentsQuery = gql`
  query SegmentsQuery {
    viewer {
      id
      segments(first: 20) {
        edges {
          node {
            id, type, iconUrl
          }
        }
      }
    }
  }
`

const ChooseSegment = ({estateReducer, goToPreviousStep, goToNextStep}) => {
  const selectSegment = (segment) => {
    estateReducer({type: 'setSegment', segment})
    goToNextStep()
  }

  return (
    <div className="new-order choose-segment">
      <Heading level={2}>Velg salgsobjekt</Heading>

      <Query
        inlineLoading
        inlineError
        query={segmentsQuery}
      >
        {({data}) => {
          return (
            <div className="segments">
              {data.viewer.segments.edges.map(({node: segment}) => (
                <div key={segment.id} className="segment">
                  <Button onClick={() => selectSegment(segment)}>
                    <img src={segment.iconUrl} alt={segment.type} />
                  </Button>
                </div>
              ))}
            </div>
          )
        }}
      </Query>

      <OrderNavigation
        onBack={goToPreviousStep}
      />
    </div>
  )
}

export default ChooseSegment
